import { createFileRoute } from "@tanstack/react-router";
import DealeriNoi from "@/pages/DealeriNoi";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dealeri/")({
  head: () => routeHead("/dealeri/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealeriNoi />
  );
}
